import { render, staticRenderFns } from "./habitWakeUpForm.vue?vue&type=template&id=2c740e56&scoped=true"
import script from "./habitWakeUpForm.vue?vue&type=script&lang=js"
export * from "./habitWakeUpForm.vue?vue&type=script&lang=js"
import style0 from "./habitWakeUpForm.vue?vue&type=style&index=0&id=2c740e56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c740e56",
  null
  
)

export default component.exports